module.exports = __webpack_public_path__ + "img/dreamhack.b835a002.png";